/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getFeedGenerators.defs.js'
export { main as default } from './getFeedGenerators.defs.js'
